import { Optional, Inject, InjectionToken, Injectable } from '@angular/core';
import { Route } from '@angular/router';

export const ENVIRONMENT = new InjectionToken<{[key: string]: any}>('environment');

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly env: any;

  constructor(@Optional() @Inject(ENVIRONMENT) environment: any) {
    this.env = environment !== null ? environment : {};
  }

  getValue(key: string, defaultValue?: any): any {
    return this.env[key] || defaultValue;
  }
}

export interface IEnvironment {
  production: boolean;
  name: EnvironmentNames;
  module: PlaningModules;
  routes: Route[];
}

export enum PlaningModules {
  SLAdmin,
  SLPortal
}

export enum EnvironmentNames {
  Local,
  Production
}
